import { render, staticRenderFns } from "./UsuariosComponent.vue?vue&type=template&id=0b3af380&scoped=true"
import script from "./UsuariosComponent.vue?vue&type=script&lang=js"
export * from "./UsuariosComponent.vue?vue&type=script&lang=js"
import style0 from "./UsuariosComponent.vue?vue&type=style&index=0&id=0b3af380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3af380",
  null
  
)

export default component.exports